module.exports = __webpack_public_path__ + "img/lx_bg.f7480fd8.png";